import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const FilterBar = ({ 
  filters, 
  onFilterChange, 
  onSearch, 
  onClearFilters, 
  searchQuery,
  currentLanguage = 'fr' 
}) => {
  const labels = {
    fr: {
      search: 'Rechercher un pèlerin',
      searchPlaceholder: 'Nom, passeport, téléphone...',
      group: 'Groupe',
      allGroups: 'Tous les groupes',
      visaStatus: 'Statut visa',
      allVisas: 'Tous les statuts',
      documentStatus: 'Documents',
      allDocuments: 'Tous les documents',
      paymentStatus: 'Paiement',
      allPayments: 'Tous les paiements',
      clearFilters: 'Réinitialiser',
      apply: 'Appliquer'
    },
    ar: {
      search: 'البحث عن حاج',
      searchPlaceholder: 'الاسم، جواز السفر، الهاتف...',
      group: 'المجموعة',
      allGroups: 'كل المجموعات',
      visaStatus: 'حالة التأشيرة',
      allVisas: 'كل الحالات',
      documentStatus: 'الوثائق',
      allDocuments: 'كل الوثائق',
      paymentStatus: 'الدفع',
      allPayments: 'كل المدفوعات',
      clearFilters: 'إعادة تعيين',
      apply: 'تطبيق'
    }
  };

  const groupOptions = [
    { value: 'all', label: labels?.[currentLanguage]?.allGroups },
    { value: 'omra-2026-01', label: 'Omra Janvier 2026 - Groupe A' },
    { value: 'omra-2026-02', label: 'Omra Février 2026 - Groupe B' },
    { value: 'hajj-2026', label: 'Hajj 2026 - Groupe Principal' },
    { value: 'omra-2026-03', label: 'Omra Mars 2026 - Groupe C' }
  ];

  const visaStatusOptions = [
    { value: 'all', label: labels?.[currentLanguage]?.allVisas },
    { value: 'approved', label: currentLanguage === 'fr' ? 'Approuvé' : 'موافق عليه' },
    { value: 'pending', label: currentLanguage === 'fr' ? 'En attente' : 'قيد الانتظار' },
    { value: 'rejected', label: currentLanguage === 'fr' ? 'Rejeté' : 'مرفوض' },
    { value: 'not_applied', label: currentLanguage === 'fr' ? 'Non demandé' : 'لم يتم التقديم' }
  ];

  const documentStatusOptions = [
    { value: 'all', label: labels?.[currentLanguage]?.allDocuments },
    { value: 'complete', label: currentLanguage === 'fr' ? 'Complets' : 'مكتملة' },
    { value: 'incomplete', label: currentLanguage === 'fr' ? 'Incomplets' : 'غير مكتملة' },
    { value: 'missing', label: currentLanguage === 'fr' ? 'Manquants' : 'مفقودة' }
  ];

  const paymentStatusOptions = [
    { value: 'all', label: labels?.[currentLanguage]?.allPayments },
    { value: 'paid', label: currentLanguage === 'fr' ? 'Payé' : 'مدفوع' },
    { value: 'partial', label: currentLanguage === 'fr' ? 'Partiel' : 'جزئي' },
    { value: 'pending', label: currentLanguage === 'fr' ? 'En attente' : 'قيد الانتظار' },
    { value: 'overdue', label: currentLanguage === 'fr' ? 'En retard' : 'متأخر' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-warm mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div className="lg:col-span-3">
          <Input
            type="search"
            placeholder={labels?.[currentLanguage]?.searchPlaceholder}
            value={searchQuery}
            onChange={(e) => onSearch(e?.target?.value)}
            className="w-full"
          />
        </div>

        <Select
          label={labels?.[currentLanguage]?.group}
          options={groupOptions}
          value={filters?.group}
          onChange={(value) => onFilterChange('group', value)}
        />

        <Select
          label={labels?.[currentLanguage]?.visaStatus}
          options={visaStatusOptions}
          value={filters?.visaStatus}
          onChange={(value) => onFilterChange('visaStatus', value)}
        />

        <Select
          label={labels?.[currentLanguage]?.documentStatus}
          options={documentStatusOptions}
          value={filters?.documentStatus}
          onChange={(value) => onFilterChange('documentStatus', value)}
        />

        <Select
          label={labels?.[currentLanguage]?.paymentStatus}
          options={paymentStatusOptions}
          value={filters?.paymentStatus}
          onChange={(value) => onFilterChange('paymentStatus', value)}
        />
      </div>
      <div className="flex items-center justify-end gap-3">
        <Button
          variant="outline"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          {labels?.[currentLanguage]?.clearFilters}
        </Button>
      </div>
    </div>
  );
};

export default FilterBar;